import BasicResource from '@/api/resource';

class PostbacksResource extends BasicResource {

    constructor () {
        super('postbacks');
    }

    partnersList (id) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/postbacks/partners/${id}`,
        });
    }
}

export default new PostbacksResource;
